<template>
  <div class="section-new-order">
    <div class="col-8 col-lg-8 col-xl-5 mx-auto py-xl-2">
      <div>
        <h3 class="section-title-centered text-uppercase" v-translate>Void Bill</h3>
        <textarea class="form-control" v-model="statusNote" rows="4" :placeholder="$gettext('Type a reason')"> </textarea>
        <div class="text-center pt-4">
          <button class="btn btn-primary px-5" @click="voidBill" v-translate>Void</button>
          <button class="btn btn-secondary px-4 mx-1" @click="onCancel" v-translate>Cancel</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  name: 'VoidBill',
  data() {
    return {
      statusNote: '',
    };
  },
  computed: {
    bill() { return this.getMap('bill', true) }
  },
  methods: {
    voidBill() {
      this.$store.dispatch(
                            'voidBill',
                            {
                              id: this.bill.id,
                              statusNote: this.statusNote
                            }
                          );
    },
    onCancel() {
      this.$store.dispatch('resetBill');
      this.$router.push({ name: 'order' });
    },
  },
};
</script>

<style lang="scss" scoped>
  .confirm-modal {
    text-align: center;
    padding: 1rem 1.5rem;
  }
</style>
